export function routeForPathname(pathname) {
  const normalized = `/${String(pathname ?? "").split("?")[0].split("#")[0]}`
    .replace(/\/+/g, "/")
    .replace(/\/$/, "") || "/";
  if (normalized === "/terms") return "terms";
  if (normalized === "/privacy") return "privacy";
  if (normalized === "/affiliate-disclosure") return "affiliateDisclosure";
  if (normalized === "/plans") return "plans";
  return "home";
}
